import request from './request';

export async function getDocuments(params, sorter = { createDate: 'descend' }, filter) {
  const res = await request.get('/portal/api/notice/document', {
    params: { paging: { params, sorter, filter } },
  });

  return res.status === 200 && res.data;
}

export async function getDocumentDetail(guid) {
  const res = await request.get(`/portal/api/notice/document/${guid}`);

  return res.status === 200 && res.data;
}

export async function getCategories(params) {
  const res = await request.get(`/portal/api/notice/category`, {
    params,
  });

  return res.status === 200 && res.data;
}

export default getDocuments;
